import { motion } from "framer-motion";
import { Globe, TrendingUp, Repeat, Cpu, Zap } from "lucide-react";

const CARDS = [
  {
    icon: Globe,
    title: "Marque mondiale reconnue",
    desc: "Appuyez-vous sur la puissance et la confiance de Norton, leader mondial de la cybersécurité, pour conclure vos ventes plus facilement.",
    span: "lg:col-span-8 lg:row-span-2",
    big: true,
  },
  {
    icon: TrendingUp,
    title: "Demande forte et constante",
    desc: "Le besoin de protection informatique ne faiblit jamais.",
    span: "lg:col-span-4 lg:row-span-1",
  },
  {
    icon: Repeat,
    title: "Revenus récurrents",
    desc: "Sur plusieurs années, sur chaque client acquis. Une vente = des revenus durables.",
    span: "lg:col-span-4 lg:row-span-2",
    big: true,
  },
  {
    icon: Cpu,
    title: "Système automatisé",
    desc: "100 % automatisé côté renouvellement.",
    span: "lg:col-span-4 lg:row-span-1",
  },
  {
    icon: Zap,
    title: "Modèle simple",
    desc: "Une vente unique génère plusieurs années de revenus passifs. Idéal pour les prestataires IT.",
    span: "lg:col-span-4 lg:row-span-1",
  },
];

export default function Benefits() {
  return (
    <section id="benefits" className="relative py-28 lg:py-36 px-6 md:px-12" data-testid="benefits-section">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-norton-yellow">
            🚀 Pourquoi rejoindre
          </span>
          <h2 className="text-3xl sm:text-5xl font-heading font-semibold tracking-tight mt-4 leading-tight">
            Tout pour rentabiliser <br className="hidden sm:block" /> chaque client
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 auto-rows-[180px] gap-5">
          {CARDS.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`group relative overflow-hidden rounded-2xl border border-white/10 bg-card/60 p-7 flex flex-col justify-between transition-all duration-300 hover:-translate-y-1 hover:border-norton-yellow/40 ${c.span}`}
              data-testid={`benefit-card-${i + 1}`}
            >
              <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-norton-yellow/0 blur-3xl transition-all duration-500 group-hover:bg-norton-yellow/15" />
              <div className={`flex items-center justify-center rounded-xl bg-norton-yellow/10 text-norton-yellow ${c.big ? "h-14 w-14" : "h-11 w-11"}`}>
                <c.icon className={c.big ? "h-7 w-7" : "h-5 w-5"} />
              </div>
              <div className="relative">
                <h3 className={`font-heading font-semibold ${c.big ? "text-2xl" : "text-lg"}`}>{c.title}</h3>
                <p className="text-sm text-zinc-400 mt-2 leading-relaxed">{c.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
